export var HealthCheckRoutes = {
    "/health-check-summary-report": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.employee-health-check-report",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "employeeHealthCheckReportContainer",
            }
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Health Check Summary Report | Harri"
            }
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["health_check"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./health-check.module.js");
                }
            }
        ]
    },
    "/employee-health-check-report": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.covid-19-employees-report",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "covid19EmployeesReportContainer",
            }
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Employee Health Check Report | Harri"
            }
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["health_check"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./health-check.module.js");
                }
            }
        ]
    },
    "/employee-health-check/:brandId?seed": {
        "name": "employee-health-check-live-report",
        "type": "frontend",
        "component": "liveReportContainer",
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Employee Health Check | Harri"
            }
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["health_check"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./health-check.module.js");
                }
            }
        ]
    },
    "/team-health-check": {
        "name": "appLayout.schedule.team-health-check",
        "showGlobalSearch": true,
        "type": "frontend",
        "loginRequired": true,
        "views": {
            "body": {
                "component": "teamHealthCheckContainer"
            }
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Team Health Check | Harri"
            }
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["health_check"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./health-check.module.js");
                }
            }
        ]
    }
};
